import React, { useEffect } from 'react';
import { useBondsAssetClassesContext } from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import { useBondsTileTabContext } from '@/creditflowresearch/application/Bonds/BondsTileTabContext';

import BondType from '@/creditflowresearch/domain/BondType';
import Inventory from '@/creditflowresearch/ui/components/bonds/common/BondTables/Inventory';
import Bwic from '@/creditflowresearch/ui/components/bonds/common/BondTables/Bwic';
import { BI_MODULE } from '@/condor/ui/components/FinsightManager/constants';
import { useTrackAnalytics } from '@/creditflowresearch/application/useTrackAnalytics';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';

import EmptyMessageWithLink from '@/creditflowresearch/ui/common/components/EmptyMessageWithLink';
import URL from '@/creditflowresearch/Router/urlConstants';
import InventoryRow from '@/creditflowresearch/ui/components/bonds/common/BondTables/Inventory/InventoryRow';
import BwicRow from '@/creditflowresearch/ui/components/bonds/common/BondTables/Bwic/BwicRow';
import { getColumns as getBwicHeaderColumns } from '@/creditflowresearch/ui/components/bonds/common/BondTables/Bwic/BwicColumns';
import { getColumns as getInventoryHeaderColumns } from '@/creditflowresearch/ui/components/bonds/common/BondTables/Inventory/InventoryColumns';

const BondsTables = () => {
  const { activeTab } = useBondsTileTabContext();
  const { currentAssetClass } = useBondsAssetClassesContext();
  const { trackAnalytics } = useTrackAnalytics();
  const { timeZone } = useUserTimeZoneContext();

  useEffect(() => {
    trackAnalytics({ module: BI_MODULE });
  }, []);

  if (BondType.isInventories(activeTab)) {
    return (
      <Inventory
        emptyMessage={ (
          <EmptyMessageWithLink
            text="Explore all other"
            linkTo={ `${ URL.BONDS_INVENTORIES_ABS }` }
            linkTitle="BWICS & Inventory"
          />
        ) }
        isItemsPerPageVisible={ false }
        getHeaderColumns={ getInventoryHeaderColumns }
        inventoryRow={ InventoryRow }
        currentAssetClass={ currentAssetClass }
        withSchema={ false }
      />
    );
  }

  return (
    <Bwic
      isItemsPerPageVisible={ false }
      getHeaderColumns={ getBwicHeaderColumns }
      bwicRow={ BwicRow }
      timeZone={ timeZone }
      currentAssetClass={ currentAssetClass }
      withSchema={ false }
    />
  );
};

export default BondsTables;
